export const pluralise = (text: string | undefined) => {
	text = text || '';
	if (/y$/.test(text)) {
		return text.substring(0, text.length - 1) + 'ies';
	}

	if (/ex$/.test(text) || /s$/.test(text)) {
		return text + 'es';
	}

	return text + 's';
};

export const pluraliseIf = (text: string | undefined, count: number) => {
	text = text || '';
	if (count === 1) {
		return text;
	}

	return pluralise(text);
};
